import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export interface IMuiAutocompleteOption {
    id: string;
    title: string;
}

interface IMuiAutocompleteProps {
    name?: string;
    label?: string;
    options: IMuiAutocompleteOption[];
    defaultValue?: IMuiAutocompleteOption[];
    value?: IMuiAutocompleteOption[];
    onChange?: (value: IMuiAutocompleteOption[]) => void;
    required?: boolean;
    error?: boolean;
    helperText?: string;
}

export const MuiAutocomplete = ({
    name,
    onChange,
    defaultValue,
    value,
    label,
    options,
    required,
    error,
    helperText,
}: IMuiAutocompleteProps) => {
    const handleChange = (event: any, newValue: IMuiAutocompleteOption[]) => {
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <Autocomplete
            multiple
            disableCloseOnSelect
            id={name}
            options={options}
            getOptionLabel={(option) => option.title}
            defaultValue={defaultValue}
            value={value || []}
            onChange={handleChange}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    required={required}
                    error={error}
                    helperText={helperText}
                    variant="outlined"
                    fullWidth
                />
            )}
        />
    );
};
